module.exports = __webpack_public_path__ + "static/img/AndrewHayes.d99ca52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AndrewHayes.jpg
// module id = f737
// module chunks = 0